const en = {
  translation: {
    navigation: {
      invoices: 'invoices',
      advances: 'advances',
      payments: 'payments',
      collections: 'collections',
      creditlines: 'credit lines',
    },
  },
}

export default en
